// extracted by mini-css-extract-plugin
export default {"userBlock":"userBlock_userBlock__eF+0B","userName":"userBlock_userName__BmHyZ","imageWrapper":"userBlock_imageWrapper__Yn164"};